// extracted by mini-css-extract-plugin
export var alt = "ParagraphFeaturedProperties-module--alt--93a2f";
export var container = "ParagraphFeaturedProperties-module--container--8e3e4";
export var desktopOnly = "ParagraphFeaturedProperties-module--desktopOnly--149ef";
export var main = "ParagraphFeaturedProperties-module--main--7172d";
export var mobileOnly = "ParagraphFeaturedProperties-module--mobileOnly--8a06c";
export var textLeft = "ParagraphFeaturedProperties-module--textLeft--e7125";
export var visuallyHidden = "ParagraphFeaturedProperties-module--visuallyHidden--89ef6";